import { render } from "./Headline.vue?vue&type=template&id=257c1464&scoped=true"
import script from "./Headline.vue?vue&type=script&lang=ts"
export * from "./Headline.vue?vue&type=script&lang=ts"

import "./Headline.vue?vue&type=style&index=0&id=257c1464&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-257c1464"

export default script